import { today } from "./format";

export const INVOICE_CURRENCIES = ["AED", "USD", "EUR", "TRY"];

export const amt = (value, currency = "") =>
  `${Number(value || 0).toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}${currency ? ` ${currency}` : ""}`;

export const emptyCustomer = () => ({ name: "", address: "", phone: "", web: "", email: "", trn: "" });

export const emptyInvoice = (settings = {}) => ({
  number: "",
  invoice_date: today(),
  customer: emptyCustomer(),
  items: [{ qty: "1", description: "", price: "" }],
  item_currency: settings.item_currency || "USD",
  total_currency: settings.total_currency || "AED",
  rate: String(settings.default_rate ?? 3.6725),
  vat_rate: String(settings.vat_rate ?? 5),
  vat_included: settings.vat_included ?? true,
  notes: "",
  save_customer: true,
});

export const formFromInvoice = invoice => ({
  number: invoice.number,
  invoice_date: invoice.invoice_date,
  customer: { ...emptyCustomer(), ...invoice.customer },
  items: invoice.items.map(i => ({ qty: String(i.qty), description: i.description, price: String(i.price) })),
  item_currency: invoice.item_currency,
  total_currency: invoice.total_currency,
  rate: String(invoice.rate),
  vat_rate: String(invoice.vat_rate),
  vat_included: !!invoice.vat_included,
  notes: invoice.notes || "",
  save_customer: false,
});

export const invoicePayload = form => ({
  number: form.number?.trim() || null,
  invoice_date: form.invoice_date,
  customer: form.customer,
  items: form.items
    .filter(i => i.description.trim() && Number(i.price) > 0)
    .map(i => ({ qty: Number(i.qty) || 1, description: i.description.trim(), price: Number(i.price) })),
  item_currency: form.item_currency,
  total_currency: form.total_currency,
  rate: form.item_currency === form.total_currency ? 1 : Number(form.rate) || 1,
  vat_rate: Number(form.vat_rate) || 0,
  vat_included: !!form.vat_included,
  notes: form.notes,
  save_customer: !!form.save_customer,
});

export const invoiceTotals = form => {
  const subtotalSrc = form.items.reduce((sum, i) => sum + (Number(i.qty) || 0) * (Number(i.price) || 0), 0);
  const rate = form.item_currency === form.total_currency ? 1 : Number(form.rate) || 1;
  const gross = subtotalSrc * rate;
  const factor = 1 + (Number(form.vat_rate) || 0) / 100;
  const subtotal = form.vat_included ? gross / factor : gross;
  const grand = form.vat_included ? gross : gross * factor;
  return { subtotalSrc, subtotal, vat: grand - subtotal, grand };
};
